/**
 * Order Page — form config
 * Future: fetched from Supabase
 */

const orderPage = {
  seo: {
    title: "Commander un bijou personnalisé",
    description: "Commandez votre bijou en résine personnalisé chez Sublime Résine. Remplissez le formulaire pour démarrer votre création unique avec photos ou poils de votre animal.",
    path: "/commander",
  },
  header: {
    title: "Commander",
    subtitle: "Remplissez le formulaire ci-dessous pour passer votre commande personnalisée. Nous vous contacterons pour finaliser les détails.",
  },
  typeOptions: [
    { id: "type_bo", label: "Boucles d'oreilles", isActive: true, sortOrder: 1 },
    { id: "type_br", label: "Breloque", isActive: true, sortOrder: 2 },
    { id: "type_co", label: "Collier", isActive: true, sortOrder: 3 },
    { id: "type_me", label: "Médaille", isActive: true, sortOrder: 4 },
    { id: "type_pc", label: "Porte-clés", isActive: true, sortOrder: 5 },
    { id: "type_sp", label: "Bijou souvenir avec poils", isActive: true, sortOrder: 6 },
    { id: "type_no", label: "Ornement de Noël", isActive: true, sortOrder: 7 },
    { id: "type_au", label: "Autre", isActive: true, sortOrder: 8 },
  ],
  collectionOptions: [
    { id: "opt_sp", label: "Bijoux souvenir avec poils", isActive: true, sortOrder: 1 },
    { id: "opt_bd", label: "Boucles d'oreilles", isActive: true, sortOrder: 2 },
    { id: "opt_br", label: "Breloques", isActive: true, sortOrder: 3 },
    { id: "opt_co", label: "Colliers", isActive: true, sortOrder: 4 },
    { id: "opt_me", label: "Médailles", isActive: true, sortOrder: 5 },
    { id: "opt_no", label: "Noël", isActive: true, sortOrder: 6 },
    { id: "opt_pc", label: "Porte-clés", isActive: true, sortOrder: 7 },
  ],
  successMessage: {
    title: "Demande envoyée !",
    text: "Merci pour votre commande. Nous vous contacterons bientôt pour finaliser les détails de votre création personnalisée.",
  },
};

export default orderPage;
